export const CALCULATION_FREQUENCIES = {
  weekly: {
    label: 'Week',
    adverbLabel: 'Weekly',
    value: 'weekly',
    type: 'week',
    weeksIn: 1,
    character: 'w'
  },
  fortnightly: {
    label: 'Fortnight',
    adverbLabel: 'Fortnightly',
    value: 'fortnightly',
    type: 'fortnight',
    weeksIn: 2,
    character: 'f'
  },
  monthly: {
    label: 'Month',
    adverbLabel: 'Monthly',
    value: 'monthly',
    type: 'month',
    weeksIn: 52 / 12,
    character: 'm'
  },
  yearly: {
    label: 'Year',
    adverbLabel: 'Yearly',
    value: 'yearly',
    type: 'year',
    weeksIn: 52,
    character: 'y'
  }
};

export const convertByFrequency = (weekly, frequency) => {
  let matchedFrequency = CALCULATION_FREQUENCIES[frequency];
  if (!matchedFrequency) {
    return weekly;
  }
  return weekly * matchedFrequency.weeksIn;
};

export const convertToFrequency = (amount, fromFrequency, toFrequency) => {
  let matchedFrequency = CALCULATION_FREQUENCIES[fromFrequency];
  if (!matchedFrequency) {
    return amount;
  }
  let weeklyValue = amount / matchedFrequency.weeksIn;
  return convertByFrequency(weeklyValue, toFrequency);
};
